<template>
<div class="chapter">
<div class="inner_page">
<p class="toc2"><span><b>CONTENTS</b></span></p>
<p class="toc2"><a href="#/Book1/cover">A WOMAN OF THE IRON PEOPLE</a></p>
<p class="toc1"><a href="#/Book1/section6">Part One</a></p>
<p class="toc1"><a href="#/Book1/section7">Anasu</a></p>
<p class="toc1"><a href="#/Book1/section8">Lixia</a></p>
<p class="toc1"><a href="#/Book1/section9">Enshi</a></p>
<p class="toc1"><a href="#/Book1/section10">Derek</a></p>
<p class="toc1"><span href="#/Book1/section11" title="Link target outside of Sample">Inahooli</span></p>
<p class="toc1"><span href="#/Book1/section12" title="Link target outside of Sample">Inzara</span></p>
<p class="toc1"><span href="#/Book1/section13" title="Link target outside of Sample">Part Two</span></p>
<p class="toc1"><span href="#/Book1/section14" title="Link target outside of Sample">Tanajin</span></p>
<p class="toc1"><span href="#/Book1/section15" title="Link target outside of Sample">Ulzai</span></p>
<p class="toc1"><span href="#/Book1/section16" title="Link target outside of Sample">Lixia</span></p>
<p class="toc1"><span href="#/Book1/section17" title="Link target outside of Sample">Eddie</span></p>
<p class="toc1"><span href="#/Book1/section18" title="Link target outside of Sample">Angai</span></p>
<p class="toc1"><span href="#/Book1/section19" title="Link target outside of Sample">Nia</span></p>
<p class="toc1"><span href="#/Book1/section20" title="Link target outside of Sample">Appendix A</span></p>
<p class="toc1"><span href="#/Book1/section21" title="Link target outside of Sample">Appendix B</span></p>
<p class="toc2"><a href="#/Book2/1cover">WAKING THE MOON</a></p>
<p class="toc1"><a href="#/Book2/7chap1#chap1">Prologue</a></p>
<p class="toc1"><a href="#/Book2/8chap2#chap2">PART ONE: DEPARTURE</a></p>
<p class="toc1"><a href="#/Book2/9chap3#chap3">1. The Sign</a></p>
<p class="toc1"><a href="#/Book2/10chap4#chap4">2. Raising the Naphaïm</a></p>
<p class="toc1"><a href="#/Book2/11chap5#chap5">3. Oliver and Angelica</a></p>
<p class="toc1"><a href="#/Book2/12chap6#chap6">4. The Lunula</a></p>
<p class="toc1"><a href="#/Book2/13chap7#chap7">5. The Sound of Bones and Flutes</a></p>
<p class="toc1"><a href="#/Book2/14chap8#chap8">6. The Reception</a></p>
<p class="toc1"><a href="#/Book2/15chap9#chap9">7. Night of the Electric Insects</a></p>
<p class="toc1"><a href="#/Book2/16chap10#chap10">8. Twilight at the Orphic Lodge</a></p>
<p class="toc1"><a href="#/Book2/17chap11#chap11">9. The Harrowing</a></p>
<p class="toc1"><a href="#/Book2/18chap12#chap12">PART TWO: ABSENCE</a></p>
<p class="toc1"><a href="#/Book2/19chap13#chap13">i. Pavana Lachrymæ</a></p>
<p class="toc1"><a href="#/Book2/20chap14#chap14">ii. Threnody: Storm King</a></p>
<p class="toc1"><a href="#/Book2/21chap15#chap15">iii. Lost Bells</a></p>
<p class="toc1"><a href="#/Book2/22chap16#chap16">iv. Saranbanda de la Muerta Oscura</a></p>
<p class="toc1"><a href="#/Book2/23chap17#chap17">PART THREE: RETURN</a></p>
<p class="toc1"><a href="#/Book2/24chap18#chap18">10. Ignoreland</a></p>
<p class="toc1"><a href="#/Book2/25chap19#chap19">11. Ancient Voices</a></p>
<p class="toc1"><a href="#/Book2/26chap20#chap20">12. The Priestess at Huitica </a></p>
<p class="toc1"><a href="#/Book2/27chap21#chap21">13. Other Echoes</a></p>
<p class="toc1"><a href="#/Book2/28chap22#chap22">14. Devil-Music</a></p>
<p class="toc1"><a href="#/Book2/29chap23#chap23">15. Ancient Voices (Echo)</a></p>
<p class="toc1"><a href="#/Book2/30chap24#chap24">16. Black Angels</a></p>
<p class="toc1"><a href="#/Book2/31chap25#chap25">17. Falling</a></p>
<p class="toc1"><a href="#/Book2/32chap26#chap26">18. A Meeting</a></p>
<p class="toc1"><a href="#/Book2/33chap27#chap27">19. Fire from the Middle Kingdom</a></p>
<p class="toc1"><a href="#/Book2/34chap28#chap28">20. Threnody and Breakdown</a></p>
<p class="toc1"><a href="#/Book2/35chap29#chap29">21. Waking the Moon</a></p>
<p class="toc1"><a href="#/Book2/36chap30#chap30">Coda</a></p>
<p class="toc1"><a href="#/Book2/37chap31#chap31">Author's Notes</a></p>
<p class="toc2"><span href="#/Book3/xhtml/cover" title="Link target outside of Sample">LARQUE ON THE WING</span></p>
<p class="toc1"><span href="#/Book3/xhtml/chapter001" title="Link target outside of Sample">One</span></p>
<p class="toc1"><span href="#/Book3/xhtml/chapter002" title="Link target outside of Sample">Two</span></p>
<p class="toc1"><span href="#/Book3/xhtml/chapter003" title="Link target outside of Sample">Three</span></p>
<p class="toc1"><span href="#/Book3/xhtml/chapter004" title="Link target outside of Sample">Four</span></p>
<p class="toc1"><span href="#/Book3/xhtml/chapter005" title="Link target outside of Sample">Five</span></p>
<p class="toc1"><span href="#/Book3/xhtml/chapter006" title="Link target outside of Sample">Six</span></p>
<p class="toc1"><span href="#/Book3/xhtml/chapter007" title="Link target outside of Sample">Seven</span></p>
<p class="toc1"><span href="#/Book3/xhtml/chapter008" title="Link target outside of Sample">Eight</span></p>
<p class="toc1"><span href="#/Book3/xhtml/chapter009" title="Link target outside of Sample">Nine</span></p>
<p class="toc1"><span href="#/Book3/xhtml/chapter010" title="Link target outside of Sample">Ten</span></p>
<p class="toc1"><span href="#/Book3/xhtml/chapter011" title="Link target outside of Sample">Eleven</span></p>
<p class="toc1"><span href="#/Book3/xhtml/chapter012" title="Link target outside of Sample">Twelve</span></p>
<p class="toc1"><span href="#/Book3/xhtml/chapter013" title="Link target outside of Sample">Thirteen</span></p>
<p class="toc1"><span href="#/Book3/xhtml/chapter014" title="Link target outside of Sample">Fourteen</span></p>
<p class="toc1"><span href="#/Book3/xhtml/chapter015" title="Link target outside of Sample">Fifteen</span></p>
<p class="toc1"><span href="#/Book3/xhtml/chapter016" title="Link target outside of Sample">Sixteen</span></p>
<p class="toc2"><span href="#/Comon/author" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bundle_content.vue?30399098